import { render, staticRenderFns } from "./DatesTable.vue?vue&type=template&id=a90fd858&scoped=true"
import script from "./DatesTable.vue?vue&type=script&lang=js"
export * from "./DatesTable.vue?vue&type=script&lang=js"
import style0 from "./DatesTable.vue?vue&type=style&index=0&id=a90fd858&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a90fd858",
  null
  
)

export default component.exports